import { render, staticRenderFns } from "./AxAccountChangePasswordDialog.vue?vue&type=template&id=058b99de&scoped=true"
import script from "./AxAccountChangePasswordDialog.vue?vue&type=script&lang=ts"
export * from "./AxAccountChangePasswordDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxAccountChangePasswordDialog.vue?vue&type=style&index=0&id=058b99de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b99de",
  null
  
)

export default component.exports